jQuery(document).ready(function ($) {

	//SMOOTH SCROOL
	$('.roll a').click(function(event) {
		var target = $(this.getAttribute('href'));
		if( target.length ) {
			event.preventDefault();
			$('html, body').stop().animate({
				scrollTop: target.offset().top
			}, 1000);
		}
	});

	//ABRIR MENU MOBILE
	$('.abrir-menu-container, .menu-mobile .botao-fechar').click(function(e) {
		e.preventDefault();
		if(!$('.menu-mobile').hasClass('menu-site-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	$('.menu-overlay').click(function(e) {
		e.preventDefault();
		if(!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
			abreMenu();
		} else {
			fechaMenu();
		}
	});
	function abreMenu() {
		$('.menu-mobile').addClass('menu-site-aberto');
		$('.menu-overlay').addClass('menu-overlay-aberto');
	}
	function fechaMenu() {
		$('.menu-mobile').removeClass('menu-site-aberto');
		$('.menu-overlay').removeClass('menu-overlay-aberto');
	}

	//BALAO DO WHATS
	$('a.whats').click(function(e) {
		closeWhatsBallon();
	});

	$('.whats-balao').hover(function(e) {
		closeWhatsBallon();
	});

	function closeWhatsBallon() {
		$('.whats-balao').remove();
	}

	setTimeout( function() { closeWhatsBallon(); }, 10000);

	//GALERIA
	$('.galeria-page a').magnificPopup({
		type: 'image',
		gallery:{
			enabled:true,
			tPrev: 'Anterior',
			tNext: 'Próxima',
			tCounter: '%curr% de %total%'
		}
	});

	//LINK VIDEO HOME
	$('a.link-video-home').magnificPopup({
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});

	//CARROSSEIS
	$('.parceiros-carrosel').owlCarousel({
		loop:true,
		margin:30,
		autoplay:true,
		autoplayTimeout:7000,
		dots:true,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		autoHeight: false,
		responsive:{
			0:{
				items:2
			},
			600:{
				items:3
			},
			1000:{
				items:6
			}
		}
	});

	$('.servicos-carrosel').owlCarousel({
		loop:false,
		margin:20,
		autoplay:true,
		autoplayTimeout:5000,
		dots:false,
		lazyLoad: true,
		navText:["&#8592;","&#8594;"],
		nav:true,
		autoHeight: false,
		responsive:{
			0:{
				items:1
			},
			700:{
				items:2
			},
			1000:{
				items:4
			}
		}
	});

});

window.onscroll = function() { fixHeader() };
const header = document.getElementById("topo");
function fixHeader() {
	if (window.pageYOffset > 1) {
		header.classList.add("scrooled");
	} else {
		header.classList.remove("scrooled");
	}
}